import { post, get } from '@/utils/httpHelper';

module.exports = {
  async checkAnswerInfo (params) {
    const url = `/esg/answerer/check`;
    const body = await post(url, params);
    return body.data;
  },
  async checkStatus (params) {
    const url = `/esg/answerer/checkStatus`;
    const body = await post(url, params);
    return body.data;
  },
  async callSaveAnswerInfo (params) {
    const url = `/esg/answerer/save`;
    const body = await post(url, params);
    return body.data;
  },
  async findAnswerDetailInfo (params, userType) {
    const url = `/esg/answerer/findAnswerDetail/${userType}/${params}`;
    const body = await get(url);
    return body.data;
  },
  async findAnswerDetailHistoryInfo (params, versionNo, userType) {
    const url = `/esg/answerer/findAnswerDetailHistory/${params}/${versionNo}/${userType}`;
    const body = await get(url);
    return body.data;
  }
};



// WEBPACK FOOTER //
// ./src/repositories/answerer/answerer.repository.js